import React from 'react';
import classNames from 'classnames';
var DropdownOptions = React.forwardRef(function (_ref, ref) {
  var items = _ref.items,
      currentItem = _ref.currentItem,
      onItemClick = _ref.onItemClick;
  return React.createElement("div", {
    ref: ref,
    className: "flexbox flexbox-column"
  }, items.map(function (item) {
    return React.createElement("div", {
      "data-qa": "database-column-option-change-type-".concat(item.type),
      key: item.type,
      onClick: function onClick() {
        return onItemClick(item.type);
      },
      style: {
        minWidth: 188
      },
      className: classNames('pointer', 'flexbox flexbox-align-center', 'font-size-normal', 'padding-horizontal-medium padding-vertical-normal', {
        'background-shade-50': item.type === currentItem.type,
        'background-shade-50-on-hover background-40-on-active': item.type !== currentItem.type
      })
    }, React.createElement("div", {
      className: classNames(' margin-right-normal line-height-one shade-30')
    }, item.icon || item.getIcon()), React.createElement("div", {
      className: classNames('font-weight-medium shade-10')
    }, item.label || item.getLabel()));
  }));
});
export default DropdownOptions;